import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a77c1b6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookingFormCabinet: require('/opt/cargo.front/src/components/booking/form/cabinet.vue').default,ShipmentTrackingForm: require('/opt/cargo.front/src/components/shipment/tracking-form.vue').default,BaseTabs: require('/opt/cargo.front/src/components/_override/cabinet/base/tabs.vue').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default,RzIconCheck: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-check/index.js').default,RzButton: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/button/index.js').default,BaseIcon: require('/opt/cargo.front/src/components/base/icon.vue').default})
